import { render } from "./ProgrammeDetail.vue?vue&type=template&id=02284442"
import script from "./ProgrammeDetail.vue?vue&type=script&lang=js"
export * from "./ProgrammeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__